//libs
import React, { useRef } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { UploadFile } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';
//components
import DragDrop from '@/features/media/plugins/DragDrop';

//styles
import { imageContainerStyles } from '../styles';
// types
import { ImageUploadCardProps } from '../types';

const ImageUploadCard: React.FC<ImageUploadCardProps> = (props) => {
  const { uppy } = props;

  const fileInput = useRef<DragDrop>(null);
  const showFileSelector = () => fileInput.current?.showUploadDialog();

  const { t } = useTranslation();

  return (
    <DragDrop ref={fileInput} DragView={<></>} accept="image/*" uppy={uppy}>
      <Box className="h-full py-4 px-4">
        <Box
          className={cn(
            'h-full cursor-pointer rounded-8 border border-dashed border-border-dark',
            imageContainerStyles,
          )}
          onClick={showFileSelector}>
          <Stack
            alignItems="center"
            className="h-full w-full"
            direction="col"
            justifyContent="center">
            <UploadFile className="mb-10 h-38 w-36" />
            <Typography
              className="capitalize"
              color="text-text-placeholder"
              variant="body-short-03">
              {t('Common:Image.UploadImage')}
            </Typography>
          </Stack>
        </Box>
      </Box>
    </DragDrop>
  );
};

export default ImageUploadCard;
